import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from "react-router-dom";
import { Card, Row, Col, Button } from 'react-bootstrap';
import { DataTable, CardContainer, Heading5 } from '../widgets';
import "../../../assets/scss/board.scss";
import { usePermission } from '../../helpers/common';
import NetworkRow from './NetworkRow';
import { getNetworkList } from '../../actions/networkType';
import { DataTableLoading, DataTableRecordsNotFound } from '../widgets/DataTable';
import NetworkForms from './NetworkForms';
import NetworkSwap from './NetworkSwap';

const NetworkList = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    let index = 0;
    const farmId = useSelector(state => state.farm.currentFarm.farm_uuid);
    const isRequesting = useSelector(state => state.network.networkList.isRequesting);
    const networkList = useSelector(state => state.network.networkList.payload);
    const [showModal, setShowModal] = useState(false);
    const [showSwap, setShowSwap] = useState(false);
    const [selectedNetwork, setSelectedNetwork] = useState({ device_uuid: "", networkTypeId: "", networkId: "" });
    const [selectedDeviceHistory, setSelectedDeviceHistory] = useState([]);
    const allow = usePermission();
    const isAllowEdit = allow("board-console", "edit");

    useEffect(() => {
        dispatch(getNetworkList());
        // dispatch(getUserFarmList());
    }, [])

    const handleModalClose = () => setShowModal(false);

    const handleSwapModalClose = () => setShowSwap(false);

    const handleSelectedFarm = (isShowSwap, deviceId, network_type_id, network_uuid,network_history) => {
        setShowSwap(isShowSwap);
        setSelectedNetwork({ device_uuid: deviceId, networkTypeId: network_type_id, networkId: network_uuid });
        if(network_history.length > 0){
            setSelectedDeviceHistory(network_history);
        }
    }

    return (
        <CardContainer lg={10} md={10}>
            <Card className="card-list animate animate__fadeInUp">
                <Card.Header>
                    <Row>
                        <Col>
                            <Card.Title>
                                <Heading5>Network</Heading5>
                            </Card.Title>
                        </Col>
                        <Col className='col-auto'>
                            <Button
                                className='btn btn-sm mr-2'
                                variant='success'
                                onClick={() => setShowModal(!showModal)}
                            >
                                {/* <i className='fa fa-times-circle mr-1' /> */}
                                Add Network
                            </Button>
                            <Button
                                className='btn btn-sm float-right'
                                variant='danger'
                                onClick={() => {
                                    const url = `/home/farm/${farmId}/map`;
                                    history.push(url);
                                }}>
                                <i className='fa fa-times-circle mr-1' />
                                Cancel
                            </Button>

                        </Col>
                    </Row>
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col>
                            <DataTable>
                                <DataTable.Header>
                                    <DataTable.Row>
                                        <DataTable.Cell style={{ width: "60px" }}>#</DataTable.Cell>
                                        <DataTable.Cell style={{ width: "160px" }}>Network Name</DataTable.Cell>
                                        <DataTable.Cell style={{ width: "160px" }}>Farm</DataTable.Cell>
                                        {/* <DataTable.Cell style={{ width: "240px" }}>Device Name</DataTable.Cell> */}
                                        <DataTable.Cell style={{ width: "120px" }}>Action</DataTable.Cell>
                                    </DataTable.Row>
                                </DataTable.Header>
                                <DataTable.Body>
                                    {networkList.map((network, i) => {
                                        if (network) index += 1;
                                        return (
                                            <NetworkRow
                                                key={i}
                                                setShowModal={() => setShowModal(!showModal)}
                                                setShowSwap={setShowSwap}
                                                showSwap={showSwap}
                                                network={network}
                                                index={index}
                                                handleSelectedFarm={handleSelectedFarm}
                                                isAllowEdit={isAllowEdit} />
                                        )
                                    })
                                    }
                                </DataTable.Body>
                            </DataTable>
                            {isRequesting && <DataTableLoading />}
                            {(!isRequesting && networkList.length === 0) && <DataTableRecordsNotFound />}
                        </Col>
                    </Row>
                    {showModal && <NetworkForms showModal={showModal} onHide={handleModalClose} />}
                    {showSwap && <NetworkSwap  showSwap={showSwap} onHide={handleSwapModalClose} selectedNetwork={selectedNetwork} selectedDeviceHistory={selectedDeviceHistory} setSelectedDeviceHistory={setSelectedDeviceHistory} />}
                </Card.Body>
            </Card>
        </CardContainer>
    )
}

export default NetworkList;